export const VIBE = 'vibe'
export const CHAT = 'chat'
export const TOMATO = 'tomato'
export const CUPCAKE = 'cupcake'
export const NOTE_SAVE = 'note_save'
export const NOTE_DELETE = 'note_delete'
export const CHANGE_MOOD = 'change_mood'
export const GET_WHITEBOARD = 'get_whiteboard'
export const BROADCAST_WHITEBOARD = 'broadcast_whiteboard'
export const BROADCAST_WHITEBOARD_DATA = 'broadcast_whiteboard_data'
export const ELSEWHERE = 'elsewhere'
export const QUIZ = 'quiz'
export const QUIZ_COMPLETE = 'quiz_complete'
export const MUTE = 'mute'
export const ALL = 'all'
export const WHITEBOARD_URL = 'whiteboard_url'
export const END_CALL = 'end_call'
export const HEARTBEAT = 'heartbeat'
